import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetPackagesQueryParams,
  PatchPriceArgs,
  ServicePackageWithPrice,
} from '../types/service-pricing/servicePricing.types';

export const servicePricingApi = createApi({
  reducerPath: 'servicePricingApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Packages'],
  endpoints: (builder) => ({
    getServicePackages: builder.query<
      ApiResponse<ServicePackageWithPrice[]>, // Return type (wrapped in your ApiResponse)
      GetPackagesQueryParams // Argument type
    >({
      query: ({ assessmentType, at }) => {
        return {
          url: '/v1/service-catalog/packages',
          method: 'GET',
          params: {
            assessmentType,
            at,
          },
        };
      },
      // Optional: Provides tags if you plan to invalidate this list later
      providesTags: ['Packages'],
    }),
    patchPackagePrice: builder.mutation<
      ApiResponse<any>, // Replace 'any' with the actual response type if needed
      PatchPriceArgs
    >({
      query: ({ priceId, ...patchData }) => ({
        // ⚠️ Check URL: Assuming 'prices' is under the same 'service-catalog' prefix
        url: `/v1/service-catalog/prices/${priceId}`,
        method: 'PATCH',
        body: patchData, // This sends only amountCents/currency
      }),
      // This is magic: it forces 'getServicePackages' to auto-refresh after a successful patch
      invalidatesTags: ['Packages'],
    }),
  }),
});

export const { useGetServicePackagesQuery, usePatchPackagePriceMutation } =
  servicePricingApi;
